export default {
  global: {
    create: 'Create',
    update: 'Update',
    cancel: 'Cancel',
    name: 'Name',
    description: 'Description',
    noUsers: 'No Users',
    lastModified: 'Last Modified',
    sortBy: 'Sort By',
    sortByNameAsc: 'Alphabetical (A-Z)',
    sortByNameDesc: 'Alphabetical (Z-A)'
  },
  header: {
    home: 'Home',
    about: 'About',
    features: 'Features',
    useCase: 'Use case',
    workspace: 'Workspace'
  },
  errors: {
    required: {
      email: 'Email is required!',
      password: 'Password is required!',
      matchPassword: 'Match Password is required!',
      projectName: 'Project Name is required !',
      firstName: 'First Name is required !',
      lastName: 'Last Name is required !',
      skillName: 'Skill Name is required !',
      entityName: 'Entity Name is required !',
      entityTerms: 'At least one term is required !',
      intentName: 'Intent Name is required !',
      intentTerms: 'At least one term is required !'
    },
    alreadyExists: {
      entityName: 'Entity name already used',
      intentName: 'Intent name already used'
    },
    passwordLength: 'Password must contains 6 to 20 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    emailValid: 'Email is not valid',
    login: 'Email or password is incorrect',
    emailExists: 'Email already exists'
  },
  messages: {
    accountCreated: 'You have been successfully registered. Please login',
    emailUpdated: 'You have changed your email successfully.',
    passwordUpdated: 'You have changed your password successfully.',
    forgotPassword: 'Contact the administrator to obtain a new password',
    userDelete: `User has been deleted successfully`,
    userUpdate: `User has been updated successfully`,
    userCreate: 'User has been created successfully'
  },
  login: {
    login: 'Login',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email address',
    role: 'Role',
    password: 'Password',
    matchPassword: 'Match password',
    forgotPassword: 'Forgot password?',
    haveAnAccount: 'Already have an account?',
    dontHaveAnAccount: "Don't have an account?",
    signin: {
      title: 'Sign in to Egsy.AI',
      subtitle: "Don't have an account?",
      signup: 'Sign up free!',
      button: 'Login with email'
    },
    signup: {
      title: 'Create Account',
      button: 'Sign up with email'
    },
    recover: {
      title: 'Recover your password',
      subtitle: 'Fill in you e-mail address bellow and we will send you an email with further instructions.',
      button: 'Recover your password'
    }
  },
  projects: {
    menu: {
      projects: 'Projects',
      account: 'Account',
      admin: 'Admin',
      logout: 'Logout'
    },
    create: 'Create new project',
    createProject: 'Create project',
    yourProjects: 'Your projects',
    myProjects: 'My projects',
    allProjects: 'All projects',
    noProjects: 'You have no projects',
    subtitle: 'Create and manage your existing projects below'
  },
  account: {
    changeEmail: {
      title: 'Change email'
    },
    changePassword: {
      title: 'Change password'
    },
    button: 'Save Changes'
  },
  admin: {
    users: 'Users',
    addNew: 'Add New',
    searchHint: 'Search User Name, Email, Role',
    newItem: 'New Item',
    editItem: 'Edit Item',
    deleteConfirmation: 'Are you sure you want to delete this item?',
    table: {
      lodingHint: 'Loading... Please wait',
      keys: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        actions: 'Actions'
      },
      actions: {
        cancel: 'Cancel',
        save: 'Save',
        reset: 'Reset'
      }
    }
  },
  skills: {
    create: 'Create new skill',
    createSkill: 'Create skill',
    name: 'Skill Name',

    yourProjects: 'Your projects',
    myProjects: 'My projects',
    allProjects: 'All projects',
    noProjects: 'You have no projects',
    subtitle: 'Create and manage your existing projects below'
  },
  entities: {
    search: 'Search entities',
    noEntities: 'You have no entities',
    noEntitiesFound: 'No entities match your search',
    create: 'Create new entity',
    createEntity: 'Create entity',
    name: 'Entity Name',
    terms: 'Terms',
    termsPlaceholder: 'You can add multiple terms each one in new line like below:\nhey\nhi\nhello',
    form: {
      createdSuccessfully: 'Entity created successfully',
      updatedSuccessfully: 'Entity updated successfully',
      removedSuccessfully: 'Entity removed successfully',
      error: {}
    }
  },
  intents: {
    search: 'Search intents',
    noIntents: 'You have no intents',
    noIntentsFound: 'No intents match your search',
    create: 'Create new intent',
    createIntent: 'Create intent',
    name: 'Intent Name',
    text: 'Text',
    form: {
      createdSuccessfully: 'Intent created successfully',
      updatedSuccessfully: 'Intent updated successfully',
      removedSuccessfully: 'Intent removed successfully',
      error: {}
    }
  }
};